import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { performApiRequest } from '../redux/apiData';
import { openModal as openModalActionCreator, clearModalState, updateModalOpenState } from '../redux/modal';
import withApiData from '../services/withApiData';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import { colorPalette } from '../styles/styleGuide';
import BBCode from './shared/richText/BBCode';
import withMatch from '@/hocs/withMatch';
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var match = ownProps.match;
  var _match$params = match.params,
    projectSlug = _match$params.projectSlug,
    env = _match$params.env;
  var postModalDismiss = function postModalDismiss(modalId) {
    return function () {
      if (modalId !== undefined && !!projectSlug && !!env) {
        dispatch(performApiRequest('postModalDismiss', {
          projectSlug: projectSlug,
          env: env,
          modalId: modalId
        }));
      }
    };
  };
  var closeModal = function closeModal() {
    dispatch(updateModalOpenState(false));
    dispatch(clearModalState());
  };
  return {
    openModal: function openModal(id, type, content) {
      dispatch(openModalActionCreator(type === 'general' ? colorPalette.orange : colorPalette.beige, {
        type: 'genericModal',
        onClose: postModalDismiss(id),
        componentProps: {
          id: id,
          content: content,
          onDismiss: function onDismiss() {
            postModalDismiss(id)();
            closeModal();
          }
        }
      }));
    }
  };
};

/**
 * This component is responsible for opening a modal if the page endpoint response has a item in the modals array. If the modal is closed, the dismiss endpoint is called, so the back end can track whether the user has seen the modal.
 */
var PageModalHandler = /*#__PURE__*/function (_Component) {
  function PageModalHandler() {
    var _this;
    _classCallCheck(this, PageModalHandler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PageModalHandler, [].concat(args));
    _defineProperty(_this, "openModal", function () {
      var _getPage$data;
      var _this$props = _this.props,
        getPage = _this$props.getPage,
        openModal = _this$props.openModal;
      if (!((_getPage$data = getPage.data) !== null && _getPage$data !== void 0 && (_getPage$data = _getPage$data.modals) !== null && _getPage$data !== void 0 && _getPage$data[0])) {
        return;
      }
      var _getPage$data$modals$ = getPage.data.modals[0],
        id = _getPage$data$modals$.id,
        type = _getPage$data$modals$.type,
        body = _getPage$data$modals$.body;
      if (id !== undefined && !!body && type !== '') {
        openModal(id, type, __jsx(BBCode, {
          content: body,
          "data-id": "components_PageModalHandler_BBCode"
        }));
      }
    });
    return _this;
  }
  _inherits(PageModalHandler, _Component);
  return _createClass(PageModalHandler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var getPage = this.props.getPage;
      var previousGetPage = prevProps.getPage;
      if (getPage.request.networkStatus === 'success' && previousGetPage.request.networkStatus !== 'success') {
        this.openModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(Component);
var connectApiData = withApiData({
  getPage: 'getPage'
}, function (_ref) {
  var match = _ref.match;
  return {
    getPage: {
      pagePath: getLinkFromPageObject(match.params)
    }
  };
});
export default withMatch(connectApiData(connect(null, mapDispatchToProps)(PageModalHandler)));